import React from 'react';

const Michigan = () => {
  return (
    <div>
      
    </div>
  );
}

export default Michigan;
